export default ({ app, router }) => {
  if (process.env.NODE_ENV === 'development') {
    return
  }

  // Google Tag Manager container — GA4, Google Ads and Meta tags are managed inside GTM
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-58L328CP'
  document.head.appendChild(script)

  app.config.errorHandler = function (err, vm) {
    console.error(err)
    console.error(vm)
    window.dataLayer.push({
      event: 'exception',
      description: err.stack,
      fatal: true
    })
    return false
  }

  window.onerror = function (message, source, lineno, colno, error) {
    if (error) message = error.stack
    window.dataLayer.push({
      event: 'exception',
      description: message,
      fatal: false
    })
    return false
  }

  router.afterEach((to) => {
    window.dataLayer.push({
      event: 'pageview',
      page_path: to.matched[to.matched.length - 1].path, // generic route path (/clients:id? etc, instead of /clients/69)
      page_title: to.name
    })
  })
}
